module.exports = __webpack_public_path__ + "img/img_interior04.f96eed01.jpg";